import React, { useRef, useState } from "react";
import {
  getFeedbacksSummaryDataPoints,
  getFeedbacksSummaryDataLabelsByKeyName,
} from "../../../features/manageFeedbacks/manageFeedbacksService";
import { FeedbackSummaryData } from "../../../features/manageFeedbacks/manageFeedbacksTypes";
import "./feedbacksSummary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import BackButton from "../../Buttons/BackButton/BackButton";
import { popupType } from "../../../types/types";
import { downloadSupportReport, getReportStatus, uploadReport } from "../../../services/supportService";
import { ConfirmationPopUp } from "../../popup/confirmationPopUp";
import DownloadLoader from "../../popup/downloadLoader";
import { GenericPopUp } from "../../popup/genericPopUp";
import { TranslationEnum, usePortalTranslation } from "../../../providers/TranslationProvider";
interface FeedbacksSummaryProps {
  data: FeedbackSummaryData[];
}
const FeedbacksSummary: React.FC<FeedbacksSummaryProps> = ({ data }) => {
  const { translate } = usePortalTranslation();

  const [confirmationPopUp, setConfirmationPopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [reportDownloadInProcess, setReportDownloadInProcess] = useState(false);
  const [openReportModel, setOpenReportModal] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

  const popUpSuccessMethod = useRef<any>();
  const dataPoints = getFeedbacksSummaryDataPoints();
  const createRequestBodyForReport = () => {
   
    const authContext = JSON.parse(localStorage.getItem("authContext") || "{}"); // Ensure authContext exists

    const requestBody = {
      attributes: {
        name: "FeedbackSummaryReport",
        format: "xlsx",
        loggedInUserName: authContext.user?.name || "", // Get user name safely
      },
      lob: authContext.user?.lob || ""
    };

    const dataObj = JSON.stringify(requestBody);
    generateReport(dataObj);
  };
  const openPopUp = (message: string, modalType: popupType) => {
    setGenericModalSMessage(message);
    setGenericModalState(true);
    setGenericModalType(modalType);
  };
  const generateReport = async (obj: string) => {
    const requestBody = JSON.parse(obj);
    if (reportDownloadInProcess) {
      openPopUp(translate(TranslationEnum.manage_feedbacks,"Report downloading already in progress,please wait."), "Alert");
      return;
    }
    setReportDownloadInProcess(true);
    setOpenReportModal(true);
    const response = await uploadReport(requestBody);
    checkReportStatus(response.data.id);
  };
  const checkReportStatus = async (id: string) => {
    const response = await getReportStatus(id);
    if (response.status === 200 && response.data.features.length > 0) {
      const reportMetaData = response.data.features[0];
      const status = reportMetaData.status;
      if (status === "SUCCESS" || status === "FAILURE") {
        await downloadReport(id);
        setReportDownloadInProcess(false);
        if (status === "FAILURE") {
          setOpenReportModal(false);
          openPopUp(translate(TranslationEnum.manage_feedbacks,"Something Went Wrong"), "Error");
        }
      } else {
        setTimeout(() => {
          checkReportStatus(id);
        }, 10000);
      }
    } else {
      openPopUp(
        translate(TranslationEnum.manage_feedbacks,"Looks like master data report has not been generated yet"),
        "Alert"
      );
    }
  };
  const downloadReport = async (id: string) => {
    try {
      const response = await downloadSupportReport(id);
      if (response.status === 200) {
        const disposition = response.headers["content-disposition"];

        let filename = "";
        if (disposition && disposition.indexOf("attachment") !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          }) as Blob;
          const URL = window.URL || window.webkitURL;
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          if (typeof a.download === "undefined") {
            openPopUp(translate(TranslationEnum.common_portal,"Error while downloading file"), "Alert");
          } else {
            a.href = downloadUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        } else if (
          disposition &&
          disposition.indexOf("File is too big to download") !== -1
        ) {
          openPopUp(translate(TranslationEnum.common_portal,"Error while downloading file"), "Alert");
        } else {
          openPopUp(translate(TranslationEnum.common_portal,"Error while downloading file"), "Alert");
        }
      } else {
        openPopUp(translate(TranslationEnum.common_portal,"Error while downloading file"), "Alert");
      }

      setReportDownloadInProcess(false);
      setOpenReportModal(false);
    } catch (error) {
      openPopUp(translate(TranslationEnum.common_portal,"Error while downloading file"), "Alert");
      setReportDownloadInProcess(false);
      setOpenReportModal(false);
    }
  };

  const updateConfirmationPopData = (message: string, methodHelper: any) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };
  return (
    <div className="feedbacksSummary-wrapper">
      <div className="feedbacksSummary-main">
        {dataPoints.map((dataPoint, index) => (
          <div className="feedbacksSummary-datapoint-wrapper" key={index}>
            <div className="feedbacksSummary-datapoint-label">
              {translate(TranslationEnum.manage_feedbacks, getFeedbacksSummaryDataLabelsByKeyName(
                dataPoint as keyof FeedbackSummaryData
              ) as string)}
            </div>
            {data?.length ? ( // Check if data is not null and has length
              data.map((dataItem: FeedbackSummaryData, dataIndex: number) => (
                <div
                  className="feedbacksSummary-datapoint-value"
                  key={dataIndex}
                >
                  {dataItem[dataPoint as keyof FeedbackSummaryData] !==
                  undefined
                    ? dataItem[dataPoint as keyof FeedbackSummaryData]
                    : "N/A"}{" "}
                  {/* Fallback value */}
                </div>
              ))
            ) : (
              <div>{translate(TranslationEnum.manage_feedbacks,"No data available.")}</div> // Handle case where there's no data
            )}
          </div>
        ))}
      </div>
      <div className="feedbacksSummary-buttons">
        <FontAwesomeIcon
          className="manageFeedbacks-downloadIcon"
          icon={faFileExcel}
          onClick={() => {
            setConfirmationPopUp(true);
            updateConfirmationPopData(
              translate(TranslationEnum.common_portal,"Are you sure want to export the report?"),
              createRequestBodyForReport
            );
          }}
        />
        <BackButton />
      </div>
      <GenericPopUp
          type={genericModaltype}
          message={genericModalMessage}
          openGenericModal={genericModalState}
          setOpenGenericModal={() => {
            setGenericModalState(false);
          }}
        />
      <ConfirmationPopUp
          openConfirmModal={confirmationPopUp}
          message={popUpMessage}
          setOpenConfirmModal={() => {
            setConfirmationPopUp(false);
          }}
          successMethod={popUpSuccessMethod.current}
        />
        {openReportModel ? (
        <DownloadLoader
          message={translate(TranslationEnum.common_portal,"Your report will be downloaded shortly.")}
          openReportModal={openReportModel}
          setOpenReportModal={setOpenReportModal}
        />
      ) : null}
    </div>
  );
};

export default FeedbacksSummary;
